import React from 'react';
import { Loop } from '../../../FlowConfigurationInputs/Loop/Loop';

function Repeat({ action, variables, setOpenVariable  , variableRender}) {
    return (
        <div className="form-element">
            <Loop action={action} inputName="loop" variables={variables} setOpenVariable={setOpenVariable}  variableRender={variableRender}/>
        </div>
    )
}

export default Repeat;
